export default "__VITE_ASSET__BGbB30hN__"